import React from 'react';
import PublicHeader from '../components/PublicHeader';
import Footer from '../components/Footer';
import { Card, CardContent } from '../components/ui/card';

export default function Terms() {
  return (
    <div className="min-h-screen bg-gray-50">
      <PublicHeader />
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <h1 className="text-4xl font-bold text-gray-900 mb-8">Kullanım Koşulları</h1>
        <Card>
          <CardContent className="p-8 prose max-w-none">
            <p className="text-sm text-gray-500 mb-6">Son Güncelleme: {new Date().toLocaleDateString('tr-TR')}</p>
            
            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">1. Hizmet Tanımı</h2>
            <p className="text-gray-700 mb-4">AIMERKUR, e-ticaret satıcılarına yapay zeka destekli müşteri soruları yönetim hizmeti sunmaktadır.</p>
            
            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">2. Kullanıcı Sorumlulukları</h2>
            <p className="text-gray-700 mb-4">Kullanıcılar, platformu yasal çerçevede kullanmakla yükümlüdür. API anahtarlarının güvenliğinden kullanıcı sorumludur.</p>
            
            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">3. Hizmet Kapsamı</h2>
            <p className="text-gray-700 mb-4">Platform, müşteri sorularını AI ile yanıtlama, mağaza yönetimi ve analitik hizmetleri sunmaktadır.</p>
            
            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">4. Ödeme ve Faturalama</h2>
            <p className="text-gray-700 mb-4">Aylık abonelik ücretleri aylık otomatik olarak tahsil edilir. İptal durumunda mevcut dönem sonuna kadar hizmet devam eder.</p>
            
            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">5. Gizlilik</h2>
            <p className="text-gray-700 mb-4">Kullanıcı verileri KVKK kapsamında korunmaktadır. Detaylar için KVKK Aydınlatma Metni'ni inceleyiniz.</p>
            
            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">6. Hizmetin Sonlandırılması</h2>
            <p className="text-gray-700 mb-4">AIMERKUR, uygunsuz kullanım durumunda hizmeti sonlandırma hakkını saklı tutar.</p>
            
            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">7. Değişiklikler</h2>
            <p className="text-gray-700 mb-4">Bu koşullar önceden haber verilmeksizin güncellenebilir. Kullanıcılar değişikliklerden haberdar edilir.</p>
            
            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">8. İletişim</h2>
            <p className="text-gray-700">Sorularınız için: info@aimerkur.com</p>
          </CardContent>
        </Card>
      </div>
      <Footer />
    </div>
  );
}
